<template>
  <div v-if="currentLang" class="locale-switch">
    <div class="dropdown" :class="{show: ddOpen}" v-click-outside="onClickOutside">
      <button @click="openLangDropdown" class="lang-switch" type="button" id="dropdownLang" data-toggle="dropdown" aria-haspopup="true" :aria-expanded="ddOpen">
        {{ currentLang.name }}
        <font-awesome-icon icon="chevron-down" />
      </button>
      <div class="dropdown-menu" aria-labelledby="dropdownLang"  :class="{show: ddOpen}">
        <a class="dropdown-item" href="#" v-for="(language, i) in langs" :key="`Lang${i}`" :value="language.code" @click.prevent="setLocale(language.code)">{{ language.name }}</a>
      </div>
    </div>
  </div>
</template>

<script>
// import { mapFields } from 'vuex-map-fields'
import ClickOutside from 'vue-click-outside'

export default {
  name: 'locale-switch',
  data() {
    return {
      languages: [
        { code: 'en', name: 'English' },
        { code: 'de', name: 'Deutsch' },
        { code: 'es', name: 'Español' }
      ],
      ddOpen: false,
      lang: 'en'
    }
  },
  directives: {
    ClickOutside
  },
  computed: {
    langs() {
      return this.languages.filter(l => l.code !== this.$i18n.locale)
    },
    currentLang() {
      const result = this.languages.filter(l => l.code === this.$i18n.locale)
      return result[0]
    }
  },
  methods: {
    openLangDropdown() {
      this.ddOpen = !this.ddOpen
    },
    onClickOutside() {
      this.ddOpen = false
    },
    setLocale(lang) {
      this.$i18n.locale = lang
      this.locale = lang
      this.ddOpen = false
      this.$router.push({ name: this.$router.currentRoute.name, params: { lang } })
    }
  },
  mounted() {
    this.locale = this.$i18n.locale
  }
}
</script>
